import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";

export default function VibrantWorkplace(){
    const { t } = useTranslation();
    return(
        <article>
          <section class="what-we-do vibrant-workplace mt-5">
            <div class="container">
              <div class="row mt-5">
                <div class="col">
                  <div class="content-wrapper">
                    <div class="row">
                      <div class="col">
                        <div class="section-highlight">{t('home.vibrantworkplace.section_title')}</div>
                      </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <div class="section-title">
                                <h4>{t('home.vibrantworkplace.section_title')}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="row image-container">
                      <div class="image-column">
                        <div class="image-wrapper">
                          <LazyLoadImage src={require("../../images/thm.JPG")} />
                          <div class="content-wrapper">
                            <div class="title">Rewards Town Hall Meeting 2025</div>
                          </div>
                        </div>
                        <div>
                          <div class="image-wrapper">
                            <LazyLoadImage src={require("../../images/event.jpg")} />
                            <div class="content-wrapper">
                              <div class="title">Gen AI Hackathon 2025</div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="image-wrapper">
                            <LazyLoadImage src={require("../../images/wd.jpg")} />
                            <div class="content-wrapper">
                              <div class="title">Diwali Celebrations</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="image-column">
                        <div>
                          <div class="image-wrapper">
                            <LazyLoadImage src={require("../../images/csr1.jpg")} />
                            <div class="content-wrapper">
                              <div class="title">Udavum Karangal Visit</div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="image-wrapper">
                            <LazyLoadImage src={require("../../images/obt.jpg")} />
                            <div class="content-wrapper">
                              <div class="title">Outbound Trainings</div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="image-wrapper">
                            <LazyLoadImage src={require("../../images/yoga.jpg")} />
                            <div class="content-wrapper">
                              <div class="title">Focus on overall health & wellness</div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </article>
    )
}